import axios from '@/utils/request'

export default {
  // 2020-07-29
  findByType(typeCode) {
    return axios.get('/enumerations/find-by-type?type=' + typeCode)
  },
  // 2020-07-29
  update(id, params) {
    return axios.put('/enumerations/' + id, params)
  }

}
